<h2 mat-dialog-title>{{'Import analysis' | translate}}</h2>
<mat-dialog-content
    style="background: whitesmoke; border: solid 1px; padding: 10px;"
    class="mat-typography">
    <div *ngIf="mInProgress">
        <p>{{'Importing' | translate}}</p>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div style="margin-top: 10px">
        <button [disabled]="mInProgress" style="margin: 0 10px" mat-raised-button (click)="inputFile.click()">Select file</button>
        <ng-container *ngIf="HTML_FileLoaded; else elseNofile">{{mFile?.name}}</ng-container>
        <ng-template #elseNofile>{{'No file selected' | translate}}</ng-template>
    </div>
    <input #inputFile (change)="onFileChange($event)" type="file" name="input-file" style="display: none">
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-raised-button [disabled]='mInProgress' mat-dialog-close>{{'Annuler' | translate}}</button>
    <button mat-raised-button [disabled]="!HTML_FileLoaded || mInProgress" cdkFocusInitial (click)="validerDialog()">{{'Confirm' | translate}}</button>
</mat-dialog-actions>
